/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum IssuesChartGroupBy {
    TOTAL = 'TOTAL',
    ISSUE_STATE = 'ISSUE_STATE'
}


export function IssuesChartGroupByFromJSON(json: any): IssuesChartGroupBy {
    return IssuesChartGroupByFromJSONTyped(json, false);
}

export function IssuesChartGroupByFromJSONTyped(json: any, ignoreDiscriminator: boolean): IssuesChartGroupBy {
    return json as IssuesChartGroupBy;
}

export function IssuesChartGroupByToJSON(value?: IssuesChartGroupBy | null): any {
    return value as any;
}

